import { Directive, ElementRef, AfterViewInit, Output, EventEmitter, HostListener, Input } from "@angular/core";

@Directive({
  selector: '[phoneNumberMask]'
})
export class PhoneMaskDirective implements AfterViewInit {
  @Input() phoneNumber: string;
  @Output() fullPhoneNumber: EventEmitter<string> = new EventEmitter(null);
  iti:any;
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const inputElement = this.el.nativeElement;
    this.iti = (window as any).intlTelInput(inputElement, {
      initialCountry: 'us',
      strictMode: true,
      countryOrder: ['us', 'ca', 'gb', 'de', 'mx']
    });
  }

  ngOnChanges(): void {
    if (this.phoneNumber && this.iti) {
      this.iti.setNumber(this.phoneNumber);
      this.emitPhoneNumber();
    }
  }

  @HostListener('blur')
  emitPhoneNumber(): void {
    const fullPhoneNumber = this.iti.getNumber();
    this.fullPhoneNumber.emit(fullPhoneNumber);
  }

}


// WEBPACK FOOTER //
// ./src/app/common/phone-mask/phone-mask.directive.ts